import React, { useState } from 'react';
import '../css/subscriber.css';

const Subscriber = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add your subscription logic here (e.g., sending the email to an API)
    setSubmitted(true);
  };

  return (
    <div className="subscriber-section">
      {!submitted ? (
        <>
          <h2 className="subscriber-title">Join Our Mailing List</h2>
          <p className="subscriber-text">
            Subscribe to receive the latest updates, news, and exclusive offers.
          </p>
          <form onSubmit={handleSubmit} className="subscriber-form">
            <input
              type="email"
              placeholder="Enter your email address"
              className="subscriber-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit" className="subscriber-button">
              Subscribe
            </button>
          </form>
        </>
      ) : (
        <div className="subscriber-success">
          <h2>Thank you for subscribing!</h2>
          <p>We've added you to our mailing list.</p>
        </div>
      )}
    </div>
  );
};

export default Subscriber;
